export const PendingInteractionKey = 'pending-interaction';